export const PoolLayaway = {
  HOME: "/",
  POOL: "/pool",
  ORDER: "/order",
};
